import '../style/index.less';
import { ThemeProvider } from '@mui/material';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { theme } from '../style/theme';
import { AuthComponent } from './components/AuthComponent';
import './i18n';
import { Provider } from 'react-redux';
import { setupAxiosInterceptors } from './api/AxiosClient';
import { AppStore } from './store/AppStore';

setupAxiosInterceptors(AppStore);

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <Provider store={AppStore}>
        <AuthComponent />
      </Provider>
    </ThemeProvider>
  </BrowserRouter>
);
